t = require('views/internal/teacup-with-helpers')('boards_page_activity_feed')

module.exports = t.renderable ({ memberId }) ->

  t.p ->
    t.format 'stay-up-to-date'

  t.p ->
    t.i ->
      t.format 'youre-one-of-the-few-lucky-people'

  t.a { href: 'https://trello.typeform.com/to/AKu2FL?memberid=' + memberId, target: '_blank' }, ->
    t.format 'let-us-know-what-you-think'

  t.div '.pop-over-section.pop-over-footer', ->
    t.p '.quiet', ->
      t.format 'not-interested'
      t.text ' '
      t.a '.js-disable-activity-feed', { href: '#' }, ->
        t.format 'disable-this-feature'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/activity_feed_info.coffee